import React, { useState } from 'react';
import { Table, Button, Container } from 'react-bootstrap';
import sampleEmployees from './sampleEmployees';
import AdminForm from './AdminForm';

const AdminIndex = () => {
    const [selectedEmployee, setSelectedEmployee] = useState(null);

    return (
        <div className="mt-4">
            <h2 className="mb-4">Employee Directory</h2>

            {!selectedEmployee ? (
                <Table className="my-custom-table border-collape" striped bordered hover responsive>
                    <thead>
                    <tr>
                        <th>Person Number</th>
                        <th>Surname</th>
                        <th>First Names</th>
                        <th>Country</th>
                        <th>Region 1</th>
                        <th>Business Unit Name</th>
                        <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {sampleEmployees.map((emp, index) => (
                        <tr key={index}>
                            <td>{emp['Personal Identification']['Person Number']}</td>
                            <td>{emp['Personal Identification']['Surname']}</td>
                            <td>{emp['Personal Identification']['First Names']}</td>
                            <td>{emp['Contact Information']['Country']}</td>
                            <td>{emp['Contact Information']['Region 1']}</td>
                            <td>{emp['Job and Position']['Business Unit Name']}</td>
                            <td>
                                <Button size={"sm"} variant="primary" onClick={() => setSelectedEmployee(emp)}>
                                    Open Form
                                </Button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
            ) : (
                <>
                    <div className="d-flex justify-content-end">
                        <div className="float-end">
                            <Button size="sm" variant="secondary" onClick={() => setSelectedEmployee(null)} className="mb-3">
                                Back to List
                            </Button>
                        </div>
                    </div>
                    <AdminForm initialData={selectedEmployee} />
                </>
            )}
        </div>
    );
};

export default AdminIndex;
